import React from 'react';
export function SystemImage() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-292">
      <div className="max-w-3xl mx-auto text-center" data-id="element-293">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-hero mb-8 leading-tight" data-id="element-294">
          Not random tips. A complete{' '}
          <span className="italic text-soft-gold" data-id="element-295">
            beginner-friendly system.
          </span>
        </h2>

        {/* Image */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-296">
          <img src="https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=900&h=600&fit=crop&crop=center" alt="Premium flat-lay of a smartphone, printed dog photography checklists, guide pages, and organized materials on an elegant warm desk" className="w-full h-auto object-cover" data-id="element-297" />
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-298">
          Everything is structured to help you improve faster, feel less
          overwhelmed, and{' '}
          <span className="font-semibold text-warm-hero" data-id="element-299">
            stop guessing every time you open your camera.
          </span>
        </p>
      </div>
    </section>;
}